<template>
  <page-wrapper :title="title" :hasPad="true">
    <div class="wrapper">
      <div class="d-flex flex-row-reverse mb-3">
        <language-select
          v-model="language"
          @change="handleChangeLanguage"
        ></language-select>
      </div>
      <provider-editor
        class="editor"
        v-model="form"
        :logoUrl="logoUrl"
        :disabled="isEditorDisabled"
        :isDisable="isDisable"
      ></provider-editor>
      <div class="row" v-if="!isEditorDisabled">
        <div class="col-3">
          <sc-button
            variant="danger"
            @click="handleClickRemove"
          >ลบ</sc-button>
        </div>
        <div class="col-9 text-right">
        <sc-button
          variant="secondary"
          @click="handleClickExportExcel"
        >ดาวน์โหลดข้อมูลผู้ให้บริการ</sc-button>
        <sc-button variant="primary" @click="handleClickSave">บันทึก</sc-button>
        </div>
      </div>
    </div>
  </page-wrapper>
</template>

<script>
import PageWrapper from "@/lib/components/PageWrapper";
import ScButton from "@/lib/components/ScButton";
import LanguageSelect from "@/lib/components/LanguageSelect";
import ProviderEditor from "../components/ProviderEditor";
import { baanRueJaiClient } from "@/dependencies";
import { uploadPublicImage } from "@/god";
import { localization } from "@/lib/mapper";
import { DateTime } from "luxon";

export default {
  components: {
    PageWrapper,
    ScButton,
    ProviderEditor,
    LanguageSelect
  },
  data() {
    const title = "รายละเอียดผู้ให้บริการ";
    const addressForm = {
      province: null,
      zipCode: null,
      amphurName: null,
      tumbonName: null,
    }

    const form = {
      name: null,
      remark: null,
      logoFile: null,
      providerType: "INDIVIDUAL",
      nameOnSap: null,
      taxId: null,
      houseNo: null,
      streetAddress: null,
      addressForm,
      mobileNumber: null
    };

    const logoUrl = null;

    return {
      title,
      form,
      logoUrl,
      language: localization.TH,
      isDisable: true
    };
  },
  computed: {
    isEditorDisabled() {
      return this.$isCallCenter;
    }
  },
  watch: {
    form(form, oldForm) {
      if (this.form.logoFile === oldForm.logoFile) {
        return;
      }

      this.logoUrl = URL.createObjectURL(this.form.logoFile);
    }
  },
  created() {
    this.setup();
  },
  methods: {
    setup() {
      this.setupData();
    },
    setupData() {
      this.setupForm();
    },
    async setupForm() {
      const provider = await this.fetchProvider();

      this.form = {
        name: provider.name,
        remark: provider.remark,
        logoFile: null,
        providerType: provider.provider_type,
        nameOnSap: provider.name_on_sap,
        taxId: provider.tax_id,
        houseNo: provider.house_no,
        streetAddress: provider.street_address,
        addressForm: {
          province: provider.province,
          zipCode: provider.zip_code,
          amphurName: provider.amphur_name,
          tumbonName: provider.tumbon_name
        },
        mobileNumber: provider.mobile_number,
        isVatRegistered: provider.is_vat_registered
      };
      this.logoUrl = provider.logo_url;
    },
    async fetchProvider() {
      const { id } = this.$route.params;

      const response =
        this.language === localization.TH
          ? await baanRueJaiClient.admin.subscriptions.providers.get(
              id
            )
          : await baanRueJaiClient.admin.subscriptions.providers.getLocalization(
              id,
              this.language
            );

      return response.data.result;
    },
    async handleClickSave() {
      try {
        await this.updateProvider();
        this.$router.push({ name: "ProviderListPage" });
      } catch (err) {
        alert("เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง");
        console.error(err);
      }
    },
    handleChangeLanguage() {
      this.setup();
    },
    async updateProvider() {
      const { id } = this.$route.params;
      const params = await this.getUpdateProviderParams();

      const response =
        this.language === localization.TH
          ? await baanRueJaiClient.admin.subscriptions.providers.put(
              id,
              params
            )
          : await baanRueJaiClient.admin.subscriptions.providers.putLocalization(
              id,
              params,
              this.language
            );

      return response.data.result;
    },
    async getUpdateProviderParams() {
      const {
        name,
        remark,
        logoFile,
        providerType,
        nameOnSap,
        taxId,
        isVatRegistered
      } = this.form;

      const params = {
        name,
        remark,
        provider_type: providerType,
        name_on_sap: nameOnSap,
        tax_id: taxId,
        is_vat_registered: isVatRegistered
      };

      if (logoFile) {
        params.icon = await uploadPublicImage(logoFile, name, "article");
      }

      return params;
    },
    async handleClickRemove() {
      if (!confirm("ยืนยันการลบ")) {
        return;
      }

      try {
        await this.removeProvider();
        this.$router.push({ name: "ProviderListPage" });
      } catch (err) {
        alert("เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง");
        console.error(err);
      }
    },
    async removeProvider() {
      const { id } = this.$route.params;

      await baanRueJaiClient.admin.subscriptions.providers.delete(id);
    },
    async handleClickExportExcel() {
      const { id } = this.$route.params;

      const response = await baanRueJaiClient.admin.subscriptions.providers.exportExcel(id);
      const blob = new Blob([response.data]);
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = `provider-${this.form.name}.xlsx`;
      link.click();
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";

.wrapper {
  padding: $space 0;
}

.editor {
  margin-bottom: $space;
}
</style>



// WEBPACK FOOTER //
// src/features/subscriptions/modules/providers/pages/ProviderDetailPage.vue